import { useEffect } from 'react';
import { useSignalR } from '@/providers/SignalR';
import { useQueryClient } from '@tanstack/react-query';
import { KycQueryKeys } from './useKyc';

export const useKycSignalR = () => {
  const { on, off } = useSignalR();
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleKycChanged = () => {
      queryClient.invalidateQueries({ queryKey: [KycQueryKeys.kyc] });
      queryClient.invalidateQueries({ queryKey: [KycQueryKeys.kycState] });
      queryClient.invalidateQueries({
        queryKey: [KycQueryKeys.userIdentityCard],
      });
    };

    on('kyc-changed', handleKycChanged);

    return () => {
      off('kyc-changed', handleKycChanged);
    };
  }, []);
};
